// Units for gate entries and e-bill scans.
// Values must match normalizeUnit in backend/utils/ebillParser.js
export const UNIT_OPTIONS = [
  { value: 'kg', label: 'kg' },
  { value: 'grams', label: 'grams' },
  { value: 'tons', label: 'tons' },
  { value: 'pcs', label: 'pcs' },
  { value: 'meters', label: 'meters' },
  { value: 'feet', label: 'feet' },
  { value: 'bags', label: 'bags' },
  { value: 'boxes', label: 'boxes' },
  { value: 'sets', label: 'sets' },
  { value: 'rolls', label: 'rolls' },
  { value: 'litres', label: 'litres' },
  { value: 'drums', label: 'drums' },
  { value: 'coils', label: 'coils' },
  { value: 'bundles', label: 'bundles' },
  { value: 'packets', label: 'packets' },
  { value: 'pairs', label: 'pairs' }
];

// Maps whatever a bill, scan or older entry says ("KGS", "Nos", "MT", "box") onto UNIT_OPTIONS
export const normalizeUnit = (raw) => {
  if (!raw) return '';
  const u = String(raw).toLowerCase().replace(/[.\s]/g, '');
  if (/^(kg|kgs|kilo)/.test(u)) return 'kg';
  if (/^(g|gm|gms|gram|grams)$/.test(u)) return 'grams';
  // "MT" on Indian bills is metric tonne; "MTR" is metre
  if (/^(mt|mts|ton|tons|tonne|tonnes)$/.test(u)) return 'tons';
  if (/^(pc|pcs|piece|nos|no|number|unit|ea|each)/.test(u)) return 'pcs';
  if (/^(mtr|meter|metre|m$)/.test(u)) return 'meters';
  if (/^(ft|feet|foot)/.test(u)) return 'feet';
  if (/^bag/.test(u)) return 'bags';
  if (/^(box|ctn|carton)/.test(u)) return 'boxes';
  if (/^set/.test(u)) return 'sets';
  if (/^roll/.test(u)) return 'rolls';
  if (/^(ltr|litre|liter|l$)/.test(u)) return 'litres';
  if (/^(drm|drum)/.test(u)) return 'drums';
  if (/^coil/.test(u)) return 'coils';
  if (/^(bdl|bundle)/.test(u)) return 'bundles';
  if (/^(pkt|packet|pack)/.test(u)) return 'packets';
  if (/^(pr|pair)/.test(u)) return 'pairs';
  return String(raw).toLowerCase().trim();
};

// Options for a <select>, keeping an unknown current value visible instead of blank
export const unitOptionsFor = (current) => {
  const value = normalizeUnit(current);
  if (!value || UNIT_OPTIONS.some(o => o.value === value)) return UNIT_OPTIONS;
  return [...UNIT_OPTIONS, { value, label: value }];
};
